module.exports = __webpack_public_path__ + "static/media/Excel.4c14e8a9.jpg";